import React, { useContext, useState } from "react";
import ic_mirror_1 from "../img/ic_mirror_1.png";
import ic_remove_item from "../img/ic_remove_item.png";
import "../css/CommonStyle.css";
import "../css/Cart.css";
import Header from "./Header";
import { ShoppingCartContext } from "./ShoppingCartContext";
import ic_empty_cart from "../img/ic_empty_cart.png";
import ic_no_image from "../img/ic_no_image_available_big.png";
import "../css/ItemSingleCard.css";
import { useNavigate } from "react-router-dom";

function Cart() {

    const navigate = useNavigate();

    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext)

    // localStorage starts

    let initialLocalStorageOrderItems = localStorage.getItem("autoland_ordered_items")

    console.log("initialLocalStorageOrderItems ", initialLocalStorageOrderItems)

    let initialOrderArray = null;

    if (initialLocalStorageOrderItems != null) {
        initialOrderArray = JSON.parse(initialLocalStorageOrderItems)
    }

    const [localStorageOrderItems, setLocalStorageOrderItems] = useState(initialOrderArray)

    // localStorage ends

    console.log(" shoppinCart is ", shoppingCart)

    const handleQuantityInput = (e, itemCode) => {

        console.log("e.target.value itemCode ", e.target.value, itemCode)

        if (e.target.value == "") {
            // just save empty string , becuase empty is converted to number it shows 0 in input

            const updatedItemArrayWithNewQuantity = localStorageOrderItems?.map((itemInCart) => {
                if (itemInCart.Code == itemCode) {
                    return { ...itemInCart, quantity_in_shopping_cart: "" }
                } else {
                    return itemInCart
                }
            })
            setLocalStorageOrderItems(updatedItemArrayWithNewQuantity)

        } else {


            const updatedItemArrayWithNewQuantity = localStorageOrderItems?.map((itemInCart) => {
                if (itemInCart.Code == itemCode) {
                    return { ...itemInCart, quantity_in_shopping_cart: Number(e.target.value) }
                } else {
                    return itemInCart
                }
            })
            setLocalStorageOrderItems(updatedItemArrayWithNewQuantity)

        }

    }

    const preventMouseWheelHappening = (e) => {
        console.log("do nothing on mouse wheel ")

        e.preventDefault();

    }


    const addDefaultSrc = (ev) => {
        ev.target.style.display = 'none';
        console.log("ev.target.nextElementSibling  ", ev.target.nextElementSibling)

        //ev.target.nextElementSibling.src ="../img/ic_no_image_available_big.png"
        ev.target.nextElementSibling.style.display = 'block';
    }


    const clickedOnMakeModelContinue = () => {

        let emptyQuantityItemsArray = localStorageOrderItems.filter((item)=>{
            return item.quantity_in_shopping_cart == 0 || item.quantity_in_shopping_cart == ""
        })

        if(emptyQuantityItemsArray.length > 0){
            alert("Please enter quantity correctly")
            return
        }

        navigate("/customer_details")
    }


    const removeItemFromCart = (itemCodeToRemove) => {

        let newArray = localStorageOrderItems?.filter((item) => {
            if (item.Code != itemCodeToRemove) {
                return item
            }
        })

        setLocalStorageOrderItems(newArray)

        localStorage.setItem("autoland_ordered_items", JSON.stringify(newArray))
        setShoppingCart(newArray)

    }

    const onBlurInput = (e, itemCode) => {

        console.log("onBlurInput e itemcode ", e, itemCode)

        let newArray = localStorageOrderItems?.map((item) => {
            if (item.Code == itemCode) {

                if (e.target.value == "") {
                    return { ...item, quantity_in_shopping_cart: 1 }
                } else {
                    return item
                }

            } else {
                return item
            }
        })

        setLocalStorageOrderItems(newArray)
        localStorage.setItem("autoland_ordered_items", JSON.stringify(newArray))
    }

    return (

        <div className="Cart-root-container common_page_bg">

            <div className="Header-wrapper">
                <Header />
            </div>

            {
                localStorageOrderItems == null ?

                    <div>
                        <div className="container Empty-state-container">
                            <img src={ic_empty_cart} />
                            <h6 className="mt-4">Your shopping cart is empty</h6>
                            <p className="Empty-state-container-paragraph">Looks like you haven't added anything to your cart yet</p>
                            <span className="Cart-start-shopping-button"><a href="/">Start Shopping</a></span>
                        </div>
                    </div>

                    :

                    localStorageOrderItems.length == 0 ?

                        <div>
                            <div className="container Empty-state-container">
                                <img src={ic_empty_cart} />
                                <h6 className="mt-4">Your shopping cart is empty</h6>
                                <p className="Empty-state-container-paragraph">Looks like you haven't added anything to your cart yet</p>
                                <span className="Cart-start-shopping-button"><a href="/">Start Shopping</a></span>
                            </div>
                        </div>
                        :
                        <div className="Cart-inner-container container mt-4 p-4">

                            <div className="Cart-inner-left-container">
                                <h5>Shopping Cart</h5>

                                <div className="Cart-list-container">

                                    {
                                        localStorageOrderItems?.map((item) => {
                                            return (
                                                <div className="Cart-list-item">

                                                    <img className="Cart-list-item-product-item" src={`http://autoland1.fortiddns.com:83/${item.imgPath}`}
                                                        onError={(e) => addDefaultSrc(e)} />

                                                    <img className="Cart-list-item-product-item-error" src={ic_no_image} />

                                                    <div className="Cart-short-details-wrapper">
                                                        <div className="Cart-item-brand-name">
                                                            <div>Code: {item.Code}</div>
                                                        </div>
                                                        <div>
                                                            <label className="Cart-item-name">
                                                                {item.Description}
                                                            </label>
                                                        </div>

                                                        <div className="mt-3">
                                                            AED {item.price}
                                                        </div>
                                                        <div className="Cart-quantity-and-remove-panel mt-4">
                                                            <div>
                                                                Qty
                                                                <input className="ItemDetails-quantity-input ms-2" min="1" type="number"
                                                                    onBlur={(e) => onBlurInput(e, item.Code)}
                                                                    value={item.quantity_in_shopping_cart} 
                                                                    onChange={(e) => handleQuantityInput(e, item.Code)}
                                                                    onWheel={(e) => preventMouseWheelHappening(e)} />
                                                            </div>
                                                            <div>
                                                                <button className="Cart-remove-button btn btn-light" onClick={() => removeItemFromCart(item.Code)}><img src={ic_remove_item} /> Remove</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        })
                                    }

                                </div>

                            </div>

                            <div className="Cart-inner-right-container">
                                <h5>Order Summary</h5>
                                <div className="Cart-order-summary-box">
                                    <div className="mt-2">
                                        <label>Sub Total</label>
                                        <label><span className="me-1 currency-label">AED </span>
                                            {
                                                localStorageOrderItems?.reduce((acc, curr) => {
                                                    return acc = acc + (curr.price * parseInt(curr.quantity_in_shopping_cart))
                                                }, 0)
                                            }
                                        </label>
                                    </div>
                                    <div className="mt-4">
                                        <label>Total</label>
                                        <label><span className="me-1 currency-label">AED </span>
                                            {
                                                localStorageOrderItems?.reduce((acc, curr) => {
                                                    return acc = acc + (curr.price * parseInt(curr.quantity_in_shopping_cart))
                                                }, 0)
                                            }
                                        </label>
                                    </div>
                                    <div className="mt-4">
                                        <button className="btn btn-sm btn-danger" onClick={() => clickedOnMakeModelContinue()}>Proceed to Checkout</button>
                                    </div>
                                </div>
                            </div>

                        </div>

            }



        </div>
    )
}

export default Cart;